<template>
  <div class="">
    <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
      <div class="clearfix row py-2 mb-2 no-margin">
        <div class="col-md-2 pr-0 cursor-pointer text-left pl-0 form-group">
          <label for="year" class="d-block">Select Year</label>
          <b-input-group class="mb-2">
            <b-form-select id="year" name="year" v-model="selected_fiscal_year" :options="$year_options" @change="resetFiscalYear()"></b-form-select>
          </b-input-group>
        </div>
        <div class="col-md-10 no-margin p-0">
          <div class="row d-flex justify-content-end no-margin">
            <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(0)">Preview Report</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="resetView()">Reset Selection</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="previewOrDownload(1)" >Download Report (Excel)</b-button>
          </div>
        </div>
      </div>
      <div v-if="is_grid_diplayable">
        <common-list :checkbox="checkbox" :leave_type_options="leave_type_options" :appended_column="appended_column"
          :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column"
          :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
      </div>
      <div class="" v-if="!is_grid_diplayable && is_preview">
        <h4 class="mb-3">Leave Report</h4>
        <div class="table-responsive">
            <table class="table dataTable leave-report-table">
                <thead class="table-head">
                    <tr>
                    <th>Name</th>
                    <th>Employee Code</th>
                    <th>Leave Policy</th>
                    <th>Leave Category</th>
                    <th class="text-center">Allowed</th>
                    <th class="text-center">Consumed</th>
                    <th class="text-center">Deducted</th>
                    <th class="text-center">Remaining</th>
                    <th v-if="carry == 1" class="text-center">Carry Sum</th>
                    <th v-if="carry == 1" class="text-center">Carry Forward</th>
                    <th v-if="encash == 1" class="text-center">Encash</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(pdata, empId) in preview_data">
                        <tr v-for="(leave, idx) in getAvailableLeaves(pdata)" :key="`${empId}-${leave.leave_type_id}-${idx}`" :class="{ 'group-start': idx === 0 }" >
                        <td v-if="idx === 0" :rowspan="getAvailableLeaves(pdata).length" class="align-middle"> 
                            {{ pdata.name || "-" }} 
                        </td>
                        <td v-if="idx === 0" :rowspan="getAvailableLeaves(pdata).length" class="align-middle">
                            {{ pdata.employee_code || "-" }}
                        </td>
                        <td v-if="idx === 0" :rowspan="getAvailableLeaves(pdata).length" class="align-middle" >
                            {{ pdata.leave_policy_info ? pdata.leave_policy_info.title : "-" }}
                        </td>
                        <td>{{ leave.leave_title || "-" }}</td>
                        <td class="text-center">{{ leave.leave_days ?? 0 }}</td>
                        <td class="text-center">{{ leave.leave_taken_days ?? 0 }}</td>
                        <td class="text-center">{{ leave.deducted ?? 0 }}</td>

                        <td class="text-center">
                            <b-badge :variant="Number(leave.remaining_days) > 0 ? 'success' : 'danger'"> {{ leave.remaining_days ?? 0 }} </b-badge>
                        </td>
                        <td v-if="carry == 1" class="text-center">{{ leave.carry_sum ?? 0 }}</td>
                        <td v-if="carry == 1" class="text-center">{{ leave.carried_days ?? 0 }}</td>
                        <td v-if="encash == 1" class="text-center">{{ leave.encashed ?? 0 }}</td>
                        </tr>
                    </template>
                    </tbody>
            </table>
        </div>
        </div>
    </b-overlay>
  </div>
</template>


<script>
export default {
  mounted() {},
  props: [],
  data() {
    const now = new Date();
    return {
      carry: 0,
      encash: 0,
      selected: [],
      checkbox: 1,
      is_action: 1,
      list_key: 0,
      custom_list: [],
      leave_type_options: [],
      default_column: [
        "name",
        "phone",
        "email",
        "jobposition",
        "department",
        "branch",
        "leave_policy",
      ],
      appended_column: [],
      primary_key: "employee_id",
      company_options: [],
      tmp_custom_list: [],
      years: [],

      selected_fiscal_year: "",
      current_fiscal_year: now.getFullYear(),
      employee_ids: [],
      preview_data: "",
      is_preview: 0,
      is_grid_diplayable: 1,

      showoverlay: false,
    };
  },
  methods: {
    getAvailableLeaves(pdata) {
    if (
      !pdata ||
      !pdata.leave_info ||
      !Array.isArray(pdata.leave_info.available)
    ) {
      return [];
    }

    return pdata.leave_info.available;
  },
    resetView: function () {
      this.is_grid_diplayable = 1;
      this.preview_data = "";
      this.selected = "";
      this.list_key += 1;
    },
    resetFiscalYear: function () {
      console.log("Resetted Fiscal Yera: " + this.selected_fiscal_year);
      this.$cookies.set(
        "saved_fiscal_year_in_reporting",
        this.selected_fiscal_year
      );
      this.getCustomList();
      this.resetView();
    },
    listReturn: function (data) {
      this.selected = data;

      console.log(data);
    },

    getCustomList: function () {
      if (!this.checkNet()) return false;
      let currentObj = this;
      this.showoverlay = true;
      axios
        .get(
          this.$api_url +
            "/leave-attendance/employees/list?year=" +
            this.selected_fiscal_year,
          {}
        )
        .then((response) => {
          this.tmp_custom_list = response.data.employee_data;
          this.company_options = response.data.options;
          this.leave_type_options = response.data.leave_type_options;
          this.custom_list = this.tmp_custom_list;
          this.showoverlay = false;

          this.list_key = this.list_key + 1;
        })
        .catch(function (error) {
          currentObj.serverError(error);
        });
    },
    previewOrDownload: function (flg) {
      if (!this.checkNet()) return false;

      if (typeof this.selected.selected == "undefined")
        this.$bvToast.toast("Please select employee(s) to generate report", {
          title: "Error!",
          variant: "danger",
          solid: true,
          toaster: "toaster: b-toaster-top-right",
        });
      else if (this.selected.selected == "")
        this.$bvToast.toast("Please select employee(s) to generate report", {
          title: "Error!",
          variant: "danger",
          solid: true,
          toaster: "toaster: b-toaster-top-right",
        });
      else if (typeof this.selected_fiscal_year == "undefined")
        this.$bvToast.toast("No from date selected", {
          title: "Error!",
          variant: "danger",
          solid: true,
          toaster: "toaster: b-toaster-top-right",
        });
      else {
        let currentObj = this;
        if (flg == 0) {
          this.$bvToast.toast(
            "We are generating the report, this may take a while, please hold tight.",
            {
              title: `Info`,
              variant: "info",
              solid: true,
            }
          );
        } else if (flg == 1) {
          this.$bvToast.toast(
            "We are downloading the report, this may take a while, please hold tight.",
            {
              title: `Info`,
              variant: "info",
              solid: true,
            }
          );
        }

        this.showoverlay = true;

        axios
          .post(this.$api_url + "/leave-attendance/leave/report", {
            //  params: {
            employee_ids: this.selected.selected,
            from_date: this.day_one,
            fiscal_year: this.selected_fiscal_year,
            is_export: flg,
            leave_type_id: this.selected.leave_type_id,
            // }
          })
          .then(
            function (response) {
              {
                this.showoverlay = false;
                console.log("From response recieve");

                if (flg == 0) {
                  this.preview_data = response.data;
                  console.log(response.data);
                  this.is_preview = 1;
                  this.is_grid_diplayable = 0;
                } else if (flg == 1) {
                  var fileURL = response.data;

                  this.downloadFileContent(fileURL);
                }
              }
            }.bind(this)
          )
          .catch(function (error) {
            currentObj.serverError(error);
          });
      }
    },
    get_current_fiscal_year: function () {
      if (!this.checkNet()) return false;
      let currentObj = this;
      this.showoverlay = true;
      axios
        .get(this.$api_url + "/leave-attendance/leave-years/list", {})
        .then(
          function (response) {
            this.years = response.data;
            if (this.years && this.years.length > 0) {
              this.current_fiscal_year = this.years[0];
            }

            let saved_fiscal_year = this.$cookies.get(
              "saved_fiscal_year_in_reporting"
            );
            if (saved_fiscal_year != null && saved_fiscal_year != "undefined") {
              this.selected_fiscal_year = saved_fiscal_year;
            } else {
              this.selected_fiscal_year = this.current_fiscal_year;
            }

            this.getCustomList();
            this.showoverlay = false;
          }.bind(this)
        )
        .catch(
          function (error) {
            this.showoverlay = false;
            currentObj.serverError(error);
          }.bind(this)
        );
    },

    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/front/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.carry = response.data.carry;
          this.encash = response.data.encash;
        }
      }.bind(this));
    },
  },
  created: function () {
    this.get_current_fiscal_year();
    this.getCompanyLeaveSettings();
  },
};
</script>
